import { useLocation } from "react-router-dom";
import { DraggableKaiLazy } from "@/components/DraggableKaiLazy";
import { useKaiSafe } from "@/contexts/KaiContext";

// Pages where Kai should NOT appear
const EXCLUDED_PATHS = ["/auth", "/"];

export const GlobalKai = () => {
  const location = useLocation();
  const kaiContext = useKaiSafe();
  
  // Use context name if available, otherwise fallback to localStorage
  const kaiName = kaiContext?.customName || localStorage.getItem("kai_custom_name") || "Kai";

  // Don't show on excluded paths
  if (EXCLUDED_PATHS.includes(location.pathname)) {
    return null;
  }

  // Check visibility from context or localStorage
  const isVisible = kaiContext?.isVisible ?? localStorage.getItem("kai_ai_visible") !== "false";
  
  if (!isVisible) {
    return null;
  }

  return <DraggableKaiLazy customName={kaiName} />;
};
